<template>
	<div id="main">
		<div class="container">
			<div class="search-wp">
				<div class="search">
					<input type="text" placeholder="请输入您要搜索的关键字信息" v-model="search_arg">
					<input type="button" value="搜 索" @click="searchFun(search_arg)">
				</div>
			</div>
			<div class="jmain-wp" v-if='this.topNew.title != ""'>
				<div class="jmain">
					<h1 class="tver"><span @click="toMain0(topNew)">{{this.topNew.title}}</span></h1>
					<h2 class="tver" v-if="this.topNew.sub_title != '' &&this.topNew.sub_title != null">{{this.topNew.sub_title}}</h2>
				</div>
			</div>
			<div class="main">
			<!-- 	<div class="main0">
					<span @click="toMain0(topNew)">{{this.topNew.title}}</span>
				</div> -->
				<div class="main1">
					<div class="main1-1 fl">
						<div class="fmain1 flexslider">
							<ul class="slides">
								<li v-for="(item,index) in recommendList" :key="index" @click="toDetal(item)" v-if="item.id != topNew.id">
									<div class="imgbox_a">
										<img :src="icoURL+'storage/'+item.image" alt="">
										<h1 class="tver">{{item.title}}</h1>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="main1-2">
						<div class="main1-2-menu">
							<dl>
								<dd v-for="(item,index) in newsMenu" :key="index" :class="{ cur : index === curIndex }" @click="newsTab(item,index)">{{item.name}}</dd>
							</dl>
							<div class="clear"></div>
						</div>
						<div class="main1-2-div">
							<div class="main1-2-list">
								<list :listId="listId" :piece="piece_news" :topID="this.topNew.id"></list>
								<div class="more11"><span class="more11_span" @click="toList2(listId)">更多+</span></div>
							</div>
						</div>
					</div>
					<div class="clear"></div>
				</div>
				<div class="main2 mm28">
					<div class="fmain2 flexslider">
						<ul class="slides">
							<li v-for="item in linkList">
								<a :href="item.url" target="_blank" class="imgbox_a">
									<img :src="icoURL+'storage/'+item.image" alt="">
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="main3 mm28">
					<div class="main3-1 fl">
						<dl>
							<dd v-for="(item,index) in quickList" :key="index" @click="toQuick(item)">
								<div class="imgbox_a imgbox_hover">
									<img :src="icoURL+'storage/'+item.image" alt="">
								</div>
							</dd>
						</dl>
						<div class="clear"></div>
					</div>
					<div class="main3-2">
						<div class="main3-er-wp">
							<div class="main3-er fl" @click="erBig(settingObj.weChat,50)">
								<!-- <img src="/images/er1.png" alt=""> -->
								<img :src="icoURL+'storage/'+this.settingObj.weChat" alt="">
								微信公众号
								</div>
							<div class="main3-er fr" @click="erBig(settingObj.phoneWeb,51)">
								<img :src="icoURL+'storage/'+this.settingObj.phoneWeb" alt="">
								手机官网
							</div>
							<div class="clear"></div>
						</div>
					</div>
					<div class="clear"></div>
				</div>
				<div class="main4 mm28">
					<div class="main4-title">
						重点工作
					</div>
					<div class="main4-list">
						<div class="row">
							<div class="col-lg-4 col-md-6" v-for="(item,index) in workMenu" :key="index">
								<div class="title-00">
									<h1 class="fl">{{item.name}}</h1>
									<div class="fr" @click="toList(item)">更多+</div>
									<div class="clear"></div>
								</div>
								<div class="main4-list-div">
									<list :listId="item.id" :piece="piece_work"></list>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="main5 mm28">
					<div class="main5-title">
						<div class="fl"><img src="../assets/images/main5-title1.png" alt=""></div>
						<div class="fr" @click="toService()">更多服务</div>
						<div class="clear"></div>
					</div>
					<div class="main5-list owl-carousel">
						<div class="item service_item" v-for="(item,index) in serviceList" :key="index">
							<a :href="item.url" target="_blank" class="service_item_a">
								<template v-if="item.icon != null">
									<img :src="icoURL+'storage/'+item.icon" alt="">
								</template>
								<template v-else>
									<img src="/images/main5-ico1.png" alt="" >
								</template>
								<h1>{{item.name}}</h1>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/js/jquery.flexslider.js';
	import '../assets/js/owl.carousel.js';

export default {
  name: 'home',
  // components: {
		// hHeader
  // },
	data(){
		return{
			recommend:[],
			recommendString:'23,14,15,16,17,18,19,25',
			recommendList:[],
			newsMenu:[],
			curIndex:0,
			listId:'',
			workMenu:[],
			serviceList:[],
			specialList:[],
			quickList:[],
			linkList:[],
			search_arg:'',
			piece_news:10,
			piece_work:6,
			settingObj:{
				weChat:'',
				phoneWeb:''
			},
			topNew:{
				id:"",
				title:'',
				excerpt:'',
				sub_title:''
			},
			topID:''
		}
	},
	methods:{
		//请求新闻子栏目
		res_topNews(){
			this.axios.get('/api/news/topNews')
				.then(response => {
					// 处理成功情况
					if(response.data.code == 200){
						this.topNew = response.data.reslut;
						this.topID = response.data.reslut.id;
					}
				})
				.catch(error => {
					// 处理错误情况
					console.log(error);
				})
		},
		//检索
		searchFun(e){
			console.log('e',e);
			this.$router.push({
				path:'/search',
				query:{
					// category_id:item.category_id,
					keywords:e
				}
			})
		},
		//请求新闻子栏目
		res_menu(){
			this.axios.get('/api/menus/parentNumber?id=5')
				.then(response => {
					// 处理成功情况
					if(response.data.code == 200){
						this.newsMenu = response.data.reslut;
						this.listId = this.newsMenu[0].id;
						for(var i = 0 ; i < response.data.reslut.length;i++){
							this.recommend.push(response.data.reslut[i].id);
						}
						// this.recommendString = this.recommend.toString();
						this.res_reslut();
					}
				})
				.catch(error => {
					// 处理错误情况
					console.log(error);
				})
		},
		//请求办事服务子栏目
		res_service(){
			this.axios.get('/api/menus/parentNumber?id=6')
				.then(response => {
					// 处理成功情况
					if(response.data.code == 200){
						this.serviceList = response.data.reslut
						this.$nextTick(() => {
							$('.main5-list').owlCarousel({
								margin:15,
								nav:false,
								dots:false,
								smartSpeed:300,
								mouseDrag:true,
								autoplay:true,
								slideBy: "page",
								autoplayTimeout:10000,
								autoplayHoverPause:false,
								loop:false,
								rewind:true,
								responsive:{
										0:{
											items:2
										},
										768:{
											items:3
										},
										992:{
											items:5
										},
										1200:{
											items:7,
											margin:0
										}
									}
								})
						})
					}
				})
				.catch(error => {
					// 处理错误情况
					console.log(error);
				})
		},
		//请求重点工作栏目
		res_menu_work(){
			this.axios.get('/api/menus/parentNumber?id=4')
				.then(response => {
					// 处理成功情况
					if(response.data.code == 200){
						this.workMenu = response.data.reslut;
					}
				})
				.catch(error => {
					// 处理错误情况
					console.log(error);
				})
		},
		//请求快捷入口
		res_quick(){
			this.axios.get('/api/link?category_id=49')
				.then(response => {
					// 处理成功情况
					if(response.data.code == 200){
						this.quickList = response.data.reslut;
					}
				})
				.catch(error => {
					// 处理错误情况
					console.log(error);
				})
		},
		//请求推荐新闻
		res_reslut(){
			this.axios.get("/api/news/featureNews?category_id="+this.recommendString+"&number=5")
				.then(response => {
					// 处理成功情况
					if(response.data.code == 200){
						this.recommendList = response.data.reslut;
						this.$nextTick(() => {
							$(".fmain1").flexslider({
								animation : "fade",
								slideshowSpeed: 4000, //展示时间间隔ms
								animationSpeed:500, //滚动时间ms
								slideshow: true,// 载入页面时，是否自动播放
								controlNav: true,  //指示器
								directionNav: false //方向键
							});
						})
					}
				})
				.catch(error => {
					// 处理错误情况
					console.log(error);
				})
		},
		//请求中部腰带
		res_link(){
			this.axios.get('/api/link?category_id=34')
				.then(response => {
					// 处理成功情况
					if(response.data.code == 200){
						this.linkList = response.data.reslut;
						this.$nextTick(() => {
							$(".fmain2").flexslider({
								animation : "slide",
								slideshowSpeed: 4000, //展示时间间隔ms
								animationSpeed:500, //滚动时间ms
								slideshow: true,// 载入页面时，是否自动播放
								controlNav: false,  //指示器
								directionNav: false //方向键
							});
						})
					}
				})
				.catch(error => {
					// 处理错误情况
					console.log(error);
				})
		},
		newsTab(item,index){
			this.curIndex = index;
			this.listId = item.id;
		},
		//跳转新闻列表页
		toList2(e){
			console.log("toList2eee",e);
			this.$router.push({
				path:'/slider/5/elist?category_id='+e
			})
		},
		//跳转详情页
		toDetal(item){
			console.log('item',item)
			this.$router.push({
				path:'/slider/'+ item.parent_id +'/detail',
				query:{
					category_id:item.category_id,
					id:item.id
				}
			})
		},
		//重点工作列表页
		toList(item){
			console.log("toList_route",this.$route);
			this.$router.push({
				path:'/slider/'+ item.parent_id +'/elist?category_id='+item.category_id,
				query:{
					category_id:item.id
				}
			})
		},
		
		//跳转专题列表页
		// toSpecialList(item){
		// 	// console.log("toList",item);
		// 	// console.log("toList_route",this.$route);
		// 	this.$router.push({
		// 		path:'/slider/'+ item.parent_id +'/elist?category_id='+item.category_id,
		// 		query:{
		// 			category_id:item.id
		// 		}
		// 	})
		// },
		
		
		//快捷入口
		toQuick(e){
			console.log('toQuick',e);
			if(e.url != '' && e.url != null){
				window.open(e.url,'_self',false);
			}
		},
		
		//办事服务跳转频道页
		toService(){
			this.$router.push('/service?category_id=6')
		},
		//请求站点信息二维码
		res_siteInfo(){
			this.axios.get('/api/setting')
				.then(response => {
					// 处理成功情况
					if(response.data.code == 200){
							this.setting = response.data.reslut;
							this.setting.forEach(item=>{
								if(item.key == "default.wechat"){
									this.settingObj.weChat = item.value;
								}else if(item.key == "default.mobile_web"){
									this.settingObj.phoneWeb = item.value;
								}
							})
					}
				})
				.catch(error => {
					// 处理错误情况
					console.log(error);
				})
		},
		//二维码放大也
		erBig(item,e){
			console.log("itemer",item);
			this.$router.push({
				path:'/slider/'+ 2 +'/er?category_id='+e,
				query:{
					imgSrc:item
				}
			})
		},
		//topnews
		toMain0(item){
			console.log("e0e",item);
			// this.$router.push({
			// 	path:'/slider/'+ e.parent_id +'/detail?category_id='+e.category_id,
			// 	query:{
			// 		id:e.id
			// 	}
			// })
			
			if(item.outurl != '' && item.outurl != null){
				window.open(item.outurl,"_blank");
				// window.location.href = item.outurl
			}else{
				this.$router.push({
					path:'/slider/'+ item.parent_id +'/detail',
					query:{
						category_id:item.category_id,
						id:item.id
					}
				})
			}
		},
	},
	created() {
		this.res_topNews();
		this.res_menu();
		this.res_menu_work();
		this.res_service();
		this.res_link();
		this.res_quick();
		this.res_siteInfo();
	},
  mounted(){
		
  }
}
</script>

<style>
</style>